import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LoadingOverlay from './LoadingOverlay'; // Importa el overlay
import { RiCloseCircleLine } from "react-icons/ri";
import { useStateContext } from '../contexts/ContextProvider';
import { FaWaze, FaWhatsapp } from 'react-icons/fa';
import moment from 'moment-timezone';
import imageCompression from 'browser-image-compression'; // Importar la librería de compresión
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";

registerLocale("es", es);

const Toast = ({ message, type, onClose }) => {
  if (!message) return null;
  const isError = type === 'error';
  return (
    <div style={{
      position: 'fixed',
      bottom: 24,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 99999,
      width: 'calc(100% - 48px)',
      maxWidth: 560,
      background: isError ? '#991b1b' : '#854d0e',
      color: '#fff',
      borderRadius: 10,
      padding: '14px 18px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      fontSize: 15,
      fontWeight: 500,
      boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
      gap: 12,
    }}>
      <span style={{ lineHeight: 1.4 }}>{isError ? '⚠️ ' : 'ℹ️ '}{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', fontWeight: 'bold', color: '#fff', fontSize: 18, flexShrink: 0 }}>✕</button>
    </div>
  );
};

const DetalleInstalacion = ({ onClose, instalacion, onRefreshCalendar }) => {
  const [archivos, setArchivos] = useState([]);
  const [toast, setToast] = useState({ message: '', type: '' });
  const [totalM2, setTotalM2] = useState(0); // Define el estado para totalM2
  const [mostrarArchivos, setMostrarArchivos] = useState(false);
  const [coordinates, setCoordinates] = useState(null);
  const { currentColor } = useStateContext();
  const [uploadedFiles, setUploadedFiles] = useState([]); 
  const [orderConfirmed, setOrderConfirmed] = useState(false); 
  const [customerContacted, setCustomerContacted] = useState(false); 
  const [confirmationTime, setConfirmationTime] = useState(''); 
  const [isProcessing, setIsProcessing] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [contactTime, setContactTime] = useState(''); 
  const [cliente, setCliente] = useState(null);  
  const [mostrarFormulario, setMostrarFormulario] = useState(false); // Variable para mostrar el formulario
  const [habilitaCerrarInstalacion, setHabilitaCerrarInstalacion] = useState(false);
  const [isEditingDate, setIsEditingDate] = useState(false);
  const [newFechaInstalacion, setNewFechaInstalacion] = useState(null);
  const [rangoHoras, setRangoHoras] = useState('');
  const [horariosDisponibles, setHorariosDisponibles] = useState([
    { value: '9-12', label: '9:00 AM - 12:00 PM', disponible: true },
    { value: '12-15', label: '12:00 PM - 3:00 PM', disponible: true },
    { value: '15-18', label: '3:00 PM - 6:00 PM', disponible: true },
  ]);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  const [detalleCotizacion, setDetalleCotizacion] = useState({
    HoraSalida: '',
    ImagenesLink: '',
    Notas: '',
    detalle: [],
    tipo_instalacion: '',
    retiro_laminas: false,
    dificultad: '',
    tipo_propiedad: '',
    monto_retiro_laminas: 0,
    monto_dificultad: 0,
    total_cotizacion: 0,
  });
  const fetchEventosYFiltrarHorarios = async (fecha) => {
    try {
      const token = localStorage.getItem('access_token');  
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/events/events`, {
        params: { fecha: fecha.toISOString().split('T')[0] },
        headers: { Authorization: `Bearer ${token}` },
      });
  
      const eventos = response.data;
  
      const horariosOcupados = horariosDisponibles.map(horario => {
        const horarioOcupado = eventos.some(evento => {
          const eventDate = new Date(evento.start_time);
          const localStartHour = eventDate.getUTCHours() - 3; // Ajustamos a Santiago
  
          if (horario.value === '9-12' && localStartHour >= 9 && localStartHour < 12) return true;
          if (horario.value === '12-15' && localStartHour >= 12 && localStartHour < 15) return true;
          if (horario.value === '15-18' && localStartHour >= 15 && localStartHour < 18) return true;
          return false;
        });
  
        return { ...horario, disponible: !horarioOcupado };
      });
  
      setHorariosDisponibles(horariosOcupados);
    } catch (error) {
      console.error('Error al obtener eventos:', error);
    }
  };

  const handleGuardarFecha = async () => {
    if (!newFechaInstalacion || !rangoHoras) {
      alert("Selecciona una fecha y un horario antes de guardar.");
      return;
    }
  
    try {
      setLoadingMessage("Guardando nueva fecha y horario...");
      setIsProcessing(true);
      const token = localStorage.getItem('access_token');
      if (!token) throw new Error("No se ha encontrado el token de autenticación.");
  
      // Calcular start_time y end_time
      const [startHour] = rangoHoras.split('-').map(Number);
      const startDateTime = new Date(newFechaInstalacion);
      startDateTime.setUTCHours(startHour + 3); // Ajustamos a Santiago
      const endDateTime = new Date(startDateTime);
      endDateTime.setUTCHours(startDateTime.getUTCHours() + 3);
  
      const formData = new FormData();
      formData.append('fecha_instalacion', startDateTime.toISOString());
      console.error("el id es ", detalleCotizacion.event_id)
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/instalacion/instalacion/${instalacion.id_instalacion}/`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      // También actualizar el evento en el calendario
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/events/events/${detalleCotizacion.event_id}/`,
        {
          start_time: startDateTime.toISOString(),
          end_time: endDateTime.toISOString()
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      alert("Fecha y horario actualizados con éxito");
      setIsEditingDate(false);
      // 🔥 cerrar modal y refrescar calendario
      if (onClose) onClose();
      if (typeof onRefreshCalendar === 'function') {
        onRefreshCalendar(startDateTime);
      }
    } catch (error) {
    alert("Hubo un problema al actualizar la fecha y horario.");
  } finally {
    setIsProcessing(false);
  }
};
  
  const [isEditable, setIsEditable] = useState(true); // Controla si el formulario es editable
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };
  
    window.addEventListener('resize', handleResize);
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  useEffect(() => {
    if (detalleCotizacion.detalle && detalleCotizacion.detalle.length > 0) {
      const total = detalleCotizacion.detalle.reduce((total, item) => {
        return total + (parseFloat(item.m2) || 0); // Suma el valor de m2, si no está definido, suma 0
        
      }, 0);
      setTotalM2(total); // Actualiza el estado con el valor calculado
    }
  }, [detalleCotizacion.detalle]); // Recalcula totalM2 cuando detalleCotizacion.detalle cambie

  const handleVerArchivos = async () => {
    if (mostrarArchivos) {
      // Si ya se está mostrando, oculta los archivos
      setMostrarArchivos(false);
      return;
    }

    try {
      setLoadingMessage("Cargando archivos...");
      setIsProcessing(true);
      const token = localStorage.getItem('access_token');
      if (!token) {
        console.error('No se ha encontrado el token de autenticación.');
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/instalacion/instalacion/${instalacion.id_instalacion}/listar-imagenes/`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          }
        }
      );
      setArchivos(response.data.imagenes || []);
      setMostrarArchivos(true);
    } catch (error) {
    alert("Hubo un error al cargar los archivos.");
  } finally {
    setIsProcessing(false);
  }
};

  useEffect(() => {
    if (orderConfirmed && customerContacted) {
      setHabilitaCerrarInstalacion(true);
    } else {
      setHabilitaCerrarInstalacion(false);
    }
  }, [orderConfirmed, customerContacted]);

  useEffect(() => {
        setArchivos(instalacion.imagenes || []);
        setOrderConfirmed(!!instalacion.confirmar_recibida);
        setCustomerContacted(!!instalacion.confirmar_contacto);

        

        setConfirmationTime(instalacion.confirmar_recibida);
        setContactTime(instalacion.confirmar_contacto);

        setDetalleCotizacion({
            HoraSalida: instalacion.hora_salida,
            Notas: instalacion.notas_instalacion,
            detalle: instalacion.orden?.cotizacion?.detalles || [],
            tipo_instalacion: instalacion.orden?.cotizacion?.tipo_instalacion,
            retiro_laminas: instalacion.orden?.cotizacion?.retiro_laminas,
            monto_retiro_laminas: instalacion.orden?.cotizacion?.monto_retiro_laminas,
            dificultad: instalacion.orden?.cotizacion?.dificultad,
            tipo_propiedad: instalacion.orden?.cotizacion?.tipo_propiedad,
            fecha_instalacion: instalacion.orden?.fecha_instalacion,
            event_id: instalacion.orden?.event_id,
            vehicle: instalacion.orden?.vehicle || '',
        });

        setCliente({
          nombre_completo: instalacion.orden?.cotizacion?.solicitante?.nombre_completo,
          direccion_instalacion: instalacion.orden?.cotizacion?.direccion_instalacion,
          region: instalacion.orden?.cotizacion?.solicitante?.region,
          comuna: instalacion.orden?.cotizacion?.solicitante?.comuna,
          email: instalacion.orden?.cotizacion?.solicitante?.email,
          whatsapp: instalacion.orden?.cotizacion?.solicitante?.whatsapp,
        });
        
        setHabilitaCerrarInstalacion(!!(instalacion.confirmar_recibida && instalacion.confirmar_contacto));

       fetchCoordinates(); 
       if (instalacion.estado_instalacion === 'realizada') {
        setIsEditable(false);
        setMostrarFormulario(true)
      }
        if (!!instalacion.confirmar_recibida) {
          setConfirmationTime(moment(instalacion.confirmar_recibida).format('YYYY-MM-DD HH:mm')); // Mostrar la hora
        }
        if (!!instalacion.confirmar_contacto) {
          setContactTime(moment(instalacion.confirmar_contacto).format('YYYY-MM-DD HH:mm')); // Mostrar la hora
        }
  
        // Mostrar el formulario si confirmar_recibida y confirmar_contacto están presentes

        if (instalacion.confirmar_recibida  && instalacion.confirmar_contacto) {
          // Verifica si HoraSalida tiene un valor válido para mostrar el formulario
          if (instalacion.hora_salida) {
            setMostrarFormulario(true);
          } else {
            setMostrarFormulario(false);
          }
        } else {
          setMostrarFormulario(false);
        }

  }, [instalacion]);

  // Función para obtener las coordenadas desde LocationIQ
  const fetchCoordinates = async () => {
    const API_KEY = "pk.064831750bf4a0aa7e6a2765c5fe8067"; // Reemplaza con tu API key de LocationIQ
    const address = `${instalacion?.orden?.cotizacion?.direccion_instalacion || ''},${cliente?.region || ''} , Chile`.trim();
    try {
      const response = await axios.get(
        `https://us1.locationiq.com/v1/search.php`,
        {
          params: {
            key: API_KEY,
            q: address,
            format: "json",
          },
        }
      );
      // La API puede devolver múltiples resultados, usamos el primero
      const location = response.data[0];
      setCoordinates({
        lat: location.lat,
        lon: location.lon,
      });
    } catch (error) {
      console.error("Error obteniendo las coordenadas:", error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetalleCotizacion((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Manejo de archivos cargados
  const handleFileUpload = async (event) => {
    const maxFileSize = 5 * 1024 * 1024; // 5 MB
    const allowedTypes = ['image/jpeg', 'image/png'];
    const files = Array.from(event.target.files);
  
    const validFiles = [];
    for (const file of files) {
      if (!allowedTypes.includes(file.type)) {
        alert(`El archivo ${file.name} no es un formato permitido.`);
        continue;
      }
  
      try {
        const options = { maxSizeMB: 1, maxWidthOrHeight: 1920, useWebWorker: true };
        const compressedFile = await imageCompression(file, options);
  
        if (compressedFile.size > maxFileSize) {
          alert(`El archivo comprimido ${file.name} excede el tamaño permitido.`);
          continue;
        }
  
        // Convertir Blob a File
        const finalFile = new File([compressedFile], file.name, { type: file.type });
        validFiles.push(finalFile);
      } catch (error) {
        console.error(`Error al comprimir ${file.name}:`, error);
      }
    }
  
    setUploadedFiles((prevFiles) => [...prevFiles, ...validFiles]);
  };

  const handleCerrarInstalacion = async () => {
    if (isProcessing) return;
    setIsProcessing(true);
    setLoadingMessage("Cerrando instalación...");

    const { HoraSalida, Notas } = detalleCotizacion;
    if (!orderConfirmed || !customerContacted || !HoraSalida.trim() || uploadedFiles.length === 0) {
      alert('Debes completar todos los campos obligatorios y cargar al menos una imagen.');
      setIsProcessing(false);
      return;
    }

    try {
      const token = localStorage.getItem('access_token');
      if (!token) {
        console.error('No se ha encontrado el token de autenticación.');
        return;
      }
  
    // Crear un FormData para incluir las imágenes y los demás datos
    const formData = new FormData();
    formData.append('estado_instalacion', 'realizada');
    formData.append('hora_salida', new Date().toISOString());
    formData.append('notas_instalacion', Notas || 'La instalación se completó exitosamente y se contactó al cliente.');
    
    // Agregar las imágenes al FormData
    uploadedFiles.forEach((file) => {
      formData.append('imagenes[]', file);
    });
    const response = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}/api/instalacion/instalacion/actualizar-estado/${instalacion.orden?.event_id}/`,
      formData,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        }
      }
    );

    // 200 con alerta de auto-transferencia — instalación cerrada, mostrar aviso y luego cerrar
    if (response.data?.alerts && response.data.alerts.length > 0) {
      setToast({ message: `Instalación cerrada. Aviso: ${response.data.alerts.join(' | ')}`, type: 'alert' });
      if (onRefreshCalendar) onRefreshCalendar();
      setTimeout(() => { if (onClose) onClose(); }, 4000);
      return;
    }

    // 200 éxito sin incidentes
    if (onClose) onClose();

    } catch (error) {
    const status = error.response?.status;
    const errMsg = error.response?.data?.error ||
      (status === 404 ? 'Evento no encontrado.' : 'Hubo un error al cerrar la instalación.');
    setToast({ message: errMsg, type: 'error' });
  } finally {
    setIsProcessing(false);
  }
};


  const handleInstalacionLista = async () => {
    try {
      setLoadingMessage("Marcando instalación como lista...");
      setIsProcessing(true);
      // Fecha y hora actual en formato ISO
      const currentTime = new Date().toISOString();
  
      // Actualizar en el backend el campo hora_salida
      await updateInstalacion('hora_salida', currentTime);
  
      // Actualizar el estado local para reflejar el cambio
      setDetalleCotizacion((prevState) => ({
        ...prevState,
        HoraSalida: currentTime,
      }));
  
      // Mostrar el formulario
      setMostrarFormulario(true);
  
      alert('Instalación marcada como lista y hora de salida registrada.');
    } catch (error) {
    alert("Hubo un error.");
  } finally {
    setIsProcessing(false);
  }
};

  const updateInstalacion = async (field, value) => {
    try {
      const token = localStorage.getItem('access_token');
      if (!token) {
        console.error('No se ha encontrado el token de autenticación.');
        return;
      }

      const formData = new FormData();
      formData.append(field, value);

      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/api/instalacion/instalacion/${instalacion.id_instalacion}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(`Campo ${field} actualizado con éxito`);
    } catch (error) {
      console.error(`Error al actualizar el campo ${field}:`, error);
      alert('Hubo un problema al actualizar la instalación. Inténtalo nuevamente.');
    }
  };

  const buildPDF = async () => {
    const cot = instalacion.orden?.cotizacion;
    if (!cot || !cliente) return null;

    const logoRes = await fetch('/ISOLOGOTIPO_NARANJA_BLANCO.png');
    const logoBlob = await logoRes.blob();
    const logoDataUrl = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(logoBlob);
    });
    const logoImg = new Image();
    await new Promise((resolve, reject) => {
      logoImg.onload = resolve;
      logoImg.onerror = reject;
      logoImg.src = logoDataUrl;
    });
    const logoAspectRatio = logoImg.naturalWidth / logoImg.naturalHeight;

    const doc = new jsPDF({ unit: 'mm', format: 'a4' });
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const margin = { left: 15, right: 15, bottom: 20 };

    const headerBg    = [37, 109, 159];
    const accentColor = [255, 116, 58];
    const textColor   = [60, 60, 60];
    const mutedColor  = [120, 120, 120];
    const lightGray   = [245, 245, 245];

    const fechaFmt = detalleCotizacion.fecha_instalacion
      ? moment(detalleCotizacion.fecha_instalacion).format('DD/MM/YYYY')
      : '-';

    const headerH = 32;
    doc.setFillColor(...headerBg);
    doc.rect(0, 0, pageWidth, headerH, 'F');

    const logoH = 14;
    const logoW = logoH * logoAspectRatio;
    doc.addImage(logoDataUrl, 'PNG', margin.left, (headerH - logoH) / 2, logoW, logoH);

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(18);
    doc.setTextColor(255, 255, 255);
    doc.text(`Instalación N° ${instalacion.id_instalacion}`, pageWidth - margin.right, 14, { align: 'right' });

    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text(`Fecha: ${fechaFmt}`, pageWidth - margin.right, 21, { align: 'right' });

    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');
    doc.text((instalacion.estado_instalacion || 'pendiente').toUpperCase(), pageWidth - margin.right, 27, { align: 'right' });

    const colL = margin.left;
    const colR = pageWidth / 2 + 5;

    let y = headerH + 10;
    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...textColor);
    doc.text('DATOS DEL CLIENTE', colL, y);
    doc.text('DATOS DEL PROYECTO', colR, y);

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    let yL = y + 6;
    let yR = y + 6;

    // Columna izquierda — cliente
    doc.text(cliente.nombre_completo || '-', colL, yL); yL += 5;
    doc.text(cliente.email || '-', colL, yL); yL += 5;
    doc.text(cliente.whatsapp || '-', colL, yL); yL += 5;
    const dir = [cot.direccion_instalacion, cliente.comuna].filter(Boolean).join(' - ');
    doc.text(dir || '-', colL, yL); yL += 5;

    // Columna derecha — proyecto e instalación
    const fechaInst = detalleCotizacion.fecha_instalacion;
    const fechaInstFmt = fechaInst ? moment(fechaInst).format('DD/MM/YYYY') : '-';
    const horaInstFmt  = fechaInst ? moment(fechaInst).format('HH:mm') : '-';

    doc.text(`N° Cotización: ${cot.id_cotizacion}`, colR, yR); yR += 5;
    doc.text(`Dificultad: ${cot.dificultad || '-'}`, colR, yR); yR += 5;
    doc.text(`Retiro lámina: ${cot.retiro_laminas ? 'Sí' : 'No'}`, colR, yR); yR += 5;
    doc.text(`Fecha/Hora inst.: ${fechaInstFmt}  ${horaInstFmt}`, colR, yR); yR += 5;
    doc.text(`Instalador: ${detalleCotizacion.vehicle || '-'}`, colR, yR); yR += 5;

    y = Math.max(yL, yR) + 5;

    const grouped = (cot.detalles || []).reduce((acc, item) => {
      const key = `${item.item}-${item.alto}-${item.ancho}-${item.m2}-${item.total}`;
      if (!acc[key]) acc[key] = { ...item, cantidad: 1 };
      else acc[key].cantidad += 1;
      return acc;
    }, {});
    const groupedArr = Object.values(grouped);

    const tableRows = groupedArr.map(item => {
      const m2Tot = (parseFloat(item.m2) || 0) * item.cantidad;
      return [item.item, `${item.alto || 'N/A'} x ${item.ancho || 'N/A'}`, item.cantidad, `${m2Tot.toFixed(2)} m²`];
    });

    if (cot.retiro_laminas)
      tableRows.push(['Retiro de láminas', '', '', '']);
    if (cot.dificultad !== 'normal')
      tableRows.push([`Dificultad: ${cot.dificultad}`, '', '', '']);

    doc.autoTable({
      startY: y,
      margin: { left: margin.left, right: margin.right },
      head: [['Ítem', 'Medidas', 'Cant.', 'M²']],
      body: tableRows,
      styles: { fontSize: 9, textColor },
      headStyles: { fillColor: accentColor, textColor: 255, fontStyle: 'bold' },
      columnStyles: { 2: { halign: 'center' }, 3: { halign: 'center' } },
    });

    y = doc.lastAutoTable.finalY + 10;

    // Total m²
    const vX = pageWidth - margin.right - 5;
    const totBoxX = pageWidth - margin.right - 70;
    const totBoxW = 70;
    doc.setFillColor(...lightGray);
    doc.roundedRect(totBoxX, y - 3, totBoxW, 12, 2, 2, 'F');
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...textColor);
    doc.text('Total m²', totBoxX + 5, y + 4);
    doc.text(`${totalM2.toFixed(2)} m²`, vX, y + 4, { align: 'right' });
    y += 18;

    doc.setFontSize(11);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...textColor);
    doc.text('Términos y Condiciones', margin.left, y);
    y += 6;

    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    const terminos = [
      '1. Vigencia de la Cotización: 30 días desde su emisión.',
      '2. Condiciones de Pago: Abono mínimo requerido para reservar la instalación.',
      '3. Agenda: Se realiza entre 3 a 7 días hábiles después del abono.',
      '4. Garantía: Cubre desprendimiento de lámina, burbujas, descoloramiento y defectos de instalación.',
      '5. Exclusiones de Garantía: No incluye reposición de vidrios por fisuras de estrés térmico.',
      '6. Alcance del Servicio: Incluye láminas e instalación, con vida útil de hasta 10 años.',
    ];
    terminos.forEach(t => { doc.text(t, margin.left, y); y += 4; });

    const footerY = pageHeight - margin.bottom - 12;
    doc.setDrawColor(...mutedColor);
    doc.setLineWidth(0.3);
    doc.line(margin.left, footerY, pageWidth - margin.right, footerY);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(...mutedColor);
    doc.text('+56 9 66781957 | 12 Norte 785 of. 401 Edificio Pamplona | www.filmsolar.cl', pageWidth / 2, footerY + 6, { align: 'center' });

    return doc;
  };

  const handleDownloadPDF = async () => {
    try {
      setLoadingMessage('Generando PDF...');
      setIsProcessing(true);
      const doc = await buildPDF();
      if (doc) doc.save(`Instalacion_${instalacion.id_instalacion}.pdf`);
    } catch (error) {
      alert('Hubo un problema al generar el PDF.');
    } finally {
      setIsProcessing(false);
    }
  };

  const handleOrderConfirmation = async (e) => {
    const isChecked = e.target.checked;
    setOrderConfirmed(isChecked); // Actualiza el estado
    const currentTime = isChecked ? new Date().toISOString() : '';
    setConfirmationTime(currentTime);

    // Actualizar en la API
    await updateInstalacion('confirmar_recibida', currentTime);
  };

  const handleCustomerContacted = async (e) => {
    const isChecked = e.target.checked;
    setCustomerContacted(isChecked); // Actualiza el estado
    const currentTime = isChecked ? new Date().toISOString() : '';
    setContactTime(currentTime);

    // Actualizar en la API
    await updateInstalacion('confirmar_contacto', currentTime);
  };

  return (
    <>
      <div className="bg-half-transparent w-screen fixed nav-item top-0 right-0 h-full flex">
      <div className="responsive-div">
          <Toast message={toast.message} type={toast.type} onClose={() => setToast({ message: '', type: '' })} />
          <div className="flex justify-between items-center mb-6">
            <p className="font-semibold text-lg" style={{ color: '#FF743A' }}>Detalle Instalación</p>
            <button
              type="button"
              onClick={onClose}
              style={{ color: currentColor }}
              className="relative text-3xl rounded-full p-4 hover:bg-light-gray"
            >
              <RiCloseCircleLine />
            </button>
          </div>
          <div className="cotizacion-header">
            <div className="yellow-bar-left"></div>
            <h1 className="cotizacion-title">INSTALACIÓN {instalacion.id_instalacion}</h1>
            <div className="yellow-bar-right"></div>
          </div>

          {/* Información del cliente */}
          {cliente && (
            <div
              className={`cliente-info ${isSmallScreen ? "flex flex-col" : "flex flex-row justify-between"}`}
            >
              <div className={`${isSmallScreen ? "" : "left-info"}`}>
                <p><strong>Cliente: </strong>{cliente?.nombre_completo}</p>
                <p className="direccion-text">
                <strong>Dirección: </strong> 
                {(cliente?.region || '') + ' - ' + (instalacion?.orden?.cotizacion?.direccion_instalacion || '')}
                </p>
              </div>
              <div className={`${isSmallScreen ? "" : "right-info"}`}>
              <p><strong>Email: </strong><span>{cliente.email}</span></p>
                <p><strong>Teléfono/Wsp: </strong>{cliente.whatsapp}</p>
              </div>
            </div>
          )}

          <div className="cliente-info">
            <div className="left-info">
            <p><strong>Servicio:</strong> {detalleCotizacion.tipo_instalacion  || ''}</p>
            <p><strong>Estado:</strong> {instalacion.estado_instalacion}</p>       
            <p><strong>Retiro Lámina:</strong> {detalleCotizacion.retiro_laminas ? 'Sí' : 'No'}</p>
            <p><strong>Dificultad:</strong> {detalleCotizacion.dificultad || ''}</p>    
            </div>
            <div className="right-info">
              <p><strong>Fecha Inst.: {moment(detalleCotizacion.fecha_instalacion).format('YYYY-MM-DD')}</strong></p>
              <p><strong>Hora Inst.: {moment(detalleCotizacion.fecha_instalacion).format('HH:mm')}</strong> </p>
              <p><strong>Tipo Propiedad:</strong> {detalleCotizacion.tipo_propiedad || ''}</p>
              <p><strong>Vendedor:</strong> {detalleCotizacion.vehicle || 'No asignado'}</p>
            </div>
          </div>

          {/* Confirmación de orden de instalación */}
          <div className="mt-4 mb-6">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-checkbox"
                checked={orderConfirmed}
                onChange={handleOrderConfirmation}
                disabled={orderConfirmed}
              />
              <span className="ml-2 text-gray-700">Recibido</span>
            </label>
            {confirmationTime && (
              <p className="mt-2 text-green-600">{`Confirmada: ${confirmationTime}`}</p>
            )}
          </div>

          {/* Confirmación de contacto con el cliente */}
          <div className="mt-4 mb-6">
            <label className="inline-flex items-center">
              <input
                type="checkbox"
                className="form-checkbox"
                checked={customerContacted}
                onChange={handleCustomerContacted}
                disabled={customerContacted}
              />
              <span className="ml-2 text-gray-700">Cliente confirmado</span>
            </label>
            {contactTime && (
              <p className="mt-2 text-green-600">{`Contacto: ${contactTime}`}</p>
            )}
          </div>

          <div className="flex flex-col md:flex-row justify-between mt-4 space-y-2 md:space-y-0 md:space-x-4 mb-5">
            {/* Botón Waze */}
            {coordinates ? (
              <a
                href={`https://waze.com/ul?ll=${coordinates.lat},${coordinates.lon}&navigate=yes`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center bg-blue-500 text-white p-3 rounded-lg hover:bg-blue-600 transition duration-200 w-full md:w-auto"
              >
                <FaWaze className="mr-2" /> Waze
              </a>
            ) : (
              <p className="text-gray-500">Cargando coordenadas...</p>
            )}

            {/* Botón Chat con Cliente */}
            {cliente && cliente.whatsapp && (
              <a
                href={`https://wa.me/${cliente.whatsapp.replace(/[^0-9]/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center bg-green-500 text-white p-3 rounded-lg hover:bg-green-600 transition duration-200 w-full md:w-auto"
              >
                <FaWhatsapp className="mr-2" /> Chat con Cliente
              </a>
            )}

            {/* Botón Descargar PDF */}
            <button
              onClick={handleDownloadPDF}
              type="button"
              className="bg-[#FF743A] text-white p-3 rounded-lg hover:bg-[#e8632e] transition duration-200 w-full md:w-auto"
            >
              Descargar
            </button>

            {/* Botón Enviar Instalación por WhatsApp */}
            <a
              href={
                cliente
                  ? `https://web.whatsapp.com/send?phone=56974235947&text=${encodeURIComponent(
                      `Estimado Lukitas,

          Adjunto encontrará la Instalación N° ${instalacion.id_instalacion}

          Detalles de la cotización:
          - Metros cuadrados (m²): ${totalM2}
          - Tipo de servicio: ${detalleCotizacion.tipo_instalacion}
          - Fecha Instalacion: ${moment(detalleCotizacion.fecha_instalacion).format('DD-MM-YYYY')}
          - Hora Instalación: ${moment(detalleCotizacion.fecha_instalacion).format('HH:mm')}

          Ante cualquier consulta adicional, quedamos atentos para responder a la brevedad.

          Saludos cordiales,
          Equipo FilmSolar`
                    )}`
                  : '#'
              }
              target="_blank"
              rel="noopener noreferrer"
              className={`flex items-center justify-center bg-green-500 text-white p-3 rounded-lg ${
                cliente ? 'hover:bg-green-600' : 'cursor-not-allowed'
              } transition duration-200 w-full md:w-auto`}
              onClick={(e) => {
                if (!cliente) {
                  e.preventDefault();
                  alert('Los datos del cliente aún no están disponibles.');
                }
              }}
            >
              <FaWhatsapp className="mr-2" /> Enviar Instalación
            </a>
            {instalacion.estado_instalacion !== 'realizada' && (
            <button
              type="button"
              className="bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-600 transition duration-200"
              onClick={() => setIsEditingDate(true)}
            >
              Editar Fecha
            </button>
            )}
            
          </div>
{isEditingDate && (
  <div className="mt-4 flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-4">
    <h3 className="mt-2">Fecha: </h3>

    <DatePicker
    className="border p-2 rounded-lg w-full md:w-auto"
    selected={newFechaInstalacion}
    onChange={(date) => {
      setNewFechaInstalacion(date);
      fetchEventosYFiltrarHorarios(date);
    }}
    minDate={new Date()}  // Solo permite fechas futuras
    placeholderText="Nueva fecha"
    dateFormat="dd/MM/yyyy"
    calendarStartDay={1}  // 📅 Semana empieza en lunes
    filterDate={(date) => {
      const day = date.getDay();
      return day !== 0 && day !== 6; // ❌ Bloquea sábados y domingos
    }}
    locale="es"   // 👈 Traduce días/meses
  />

    {/* Selección de Horario */}
    <label className="mt-2">Horario:</label>
    <select
      className="border p-2 rounded-lg w-full md:w-auto"
      value={rangoHoras}
      onChange={(e) => setRangoHoras(e.target.value)}
    >
      <option value="">Nuevo rango de horas</option>
      {horariosDisponibles
        .filter((horario) => horario.disponible)
        .map((horario) => (
          <option key={horario.value} value={horario.value}>
            {horario.label}
          </option>
        ))}
    </select>

    {/* Botones Guardar/Cancelar */}
    <div className="flex justify-between mt-4 space-x-2">
      <button
        type="button"
        disabled={isProcessing }
        className={`bg-green-500 text-white p-3 rounded-lg transition duration-200 w-full md:w-auto ${
          isProcessing  ? "opacity-50 cursor-not-allowed" : "hover:bg-green-600"
        }`}
        onClick={handleGuardarFecha}
      >
        Guardar
      </button>
    </div>
  </div>
)}

        <table className="items-table table-auto border-collapse w-full mt-6">
            <thead>
            <tr className="bg-gray-100">
                <th>Nº</th>
                <th>Item</th>
                <th>Cant.</th>
                {isSmallScreen ? (
                  <th>Medidas</th>
                ) : (
                  <>
                    <th>Alto</th>
                    <th>Ancho</th>
                  </>
                )}
                <th>M²</th>
              </tr>
            </thead>
            <tbody>
   
              {(() => {
                // Agrupa los detalles por columnas clave
                const groupedDetails = detalleCotizacion.detalle
                ? detalleCotizacion.detalle.reduce((acc, item) => {
                    const key = `${item.item}-${item.alto}-${item.ancho}-${item.m2}-${item.total}`;
                    if (!acc[key]) {
                      acc[key] = { ...item, cantidad: 1 };
                    } else {
                      acc[key].cantidad += 1;
                    }
                    return acc;
                  }, {})
                : {};
                // Convierte el objeto agrupado en un array para iterar
                const groupedArray = Object.values(groupedDetails);

                // Renderizar filas agrupadas
                const rows = groupedArray.map((item, index) => {
                  const totalM2 = (parseFloat(item.m2) || 0) * item.cantidad; // Total m² multiplicado por cantidad

                  return (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.item}</td>
                      <td>{item.cantidad}</td>
                {isSmallScreen ? (
                  <td>{`${item.alto || 'N/A'} x ${item.ancho || 'N/A'}`}</td>
                ) : (
                  <>
                    <td>{item.alto || 'N/A'}</td>
                    <td>{item.ancho || 'N/A'}</td>
                  </>
                )}
                      <td>{totalM2 ? `${totalM2.toFixed(2)}` : 'N/A'}</td>
                    </tr>
                  );
                });

                // Agregar filas adicionales
                let extraRowIndex = groupedArray.length;
                
                if (detalleCotizacion.retiro_laminas) {
                  rows.push(
                    <tr key="retiro_laminas" className="text-center">
    
                      <td className="text-center">{++extraRowIndex}</td>
                      <td colSpan="5" className="text-center">
                        Retiro de láminas ({(detalleCotizacion.monto_retiro_laminas / 6990).toFixed(2)} m²)
                      </td>
                    
                    </tr>
                  );
                }    
                return rows;
              })()}
            </tbody>
          </table>

          {/* Monto total de m2 debajo de la tabla */}
          <div className="flex justify-between mt-2 w-full mb-3">
            <p className="font-semibold text-lg w-full text-right">
              Total m²: {totalM2.toFixed(2)} m²
            </p>
          </div>


          {mostrarFormulario ? (
            <>
              <div className="mt-6">
                <h3 className="font-semibold text-lg mb-4">Registros de instalación</h3>
                <div className="mb-4">
                  <label className="block text-gray-700">Hora de salida:</label>
                  <p className="w-full p-2 border rounded bg-gray-100">{moment(detalleCotizacion.HoraSalida).format('YYYY-MM-DD HH:mm') || 'Sin hora registrada'}</p>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700">{isEditable ? 'Cargar imágenes/videos: ' : 'Imágenes/videos cargados:'}</label>
                    {isEditable ? (
                    <>
                      <input
                        type="file"
                        className="w-full p-2 border rounded"
                        multiple
                        onChange={handleFileUpload}
                      />
                      <ul className="mt-4">
                        {uploadedFiles.map((file, index) => (
                          <li key={index} className="text-gray-700">{file.name}</li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <div>
      
                    <button
                      onClick={handleVerArchivos}
                      className="bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-600"
                    >
                      {mostrarArchivos ? "Ocultar Archivos" : "Ver Archivos"}
                    </button>
              
                    {mostrarArchivos && (
                      <ul>
                        {archivos.length > 0 ? (
                          archivos.map((archivo, index) => (
                            <li key={index}>
                              <a
                                href={archivo.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500 underline"
                              >
                                {archivo.nombre || `Archivo ${index + 1}`}
                              </a>
                            </li>
                          ))
                        ) : (
                          <p>No hay archivos disponibles.</p>
                        )}
                      </ul>
                    )}
                  </div>
                  )}
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700">Notas:</label>
                  {isEditable ? (
                    <textarea
                      name="Notas"
                      className="w-full p-2 border rounded"
                      rows="4"
                      placeholder="Notas adicionales sobre la instalación..."
                      value={detalleCotizacion.Notas}
                      onChange={handleInputChange}
                    ></textarea>
                  ) : (
                    <p className="w-full p-2 border rounded bg-gray-100">{detalleCotizacion.Notas || 'Sin notas registradas'}</p>
                  )}
                </div>
              </div>
              <div className="flex justify-between mt-4 pb-6">
              {isEditable && (
                <button
                  type="button"
                  className={`bg-green-500 text-white p-2 rounded-lg hover:bg-green-600 transition duration-200 w-full ${
                    isProcessing ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
                  onClick={handleCerrarInstalacion}
                  disabled={isProcessing}
                >
                  {isProcessing ? 'Procesando...' : 'Cerrar instalación'}
                </button>
              )}
            </div>
            </>
          ) : (
                <>
                  {habilitaCerrarInstalacion ? (
                    <button
                      type="button"
                      className="bg-blue-500 text-white p-2 rounded-lg hover:bg-blue-600 transition duration-200"
                      onClick={handleInstalacionLista}
                      disabled={isProcessing}
                    >
                      {isProcessing ? 'Procesando...' : 'Instalación Lista'}
                    </button>
                  ) : (
                    <p className="text-gray-700 p-2 rounded bg-yellow-100">
                      Recuerda checkear confirmar recepción de orden y notificación al cliente
                    </p>
                  )}
                </>
          )}
        </div>
      </div>
      {/* Overlay al guardar fecha/hora */}
      {isProcessing && <LoadingOverlay message={loadingMessage} />}
    </>
  );
};

export default DetalleInstalacion;
